import Component from '../../classes/Component';
import {$events} from "../../helpers/events";
import {$dom} from "../../helpers/dom";

const btnAttr = 'data-scroll-to';
const btnSelector = `[${btnAttr}]`;
const buyTicketSectionId = 'js-buy-ticket-section';

export default function () {

    return new Component({
        name: 'scrollTo',
        requiredTargets: btnSelector,
        onInit() {

            this.handleClick = event => {
                const btn = event.target.closest(btnSelector);

                if (btn) {
                    const targetId = btn.getAttribute(btnAttr);
                    const target = $dom.get(targetId);

                    if (
                        targetId.replace('#', '') === buyTicketSectionId
                        && $dom.exist('form', target)
                    )
                        $dom.get('form', target).elements[0]?.focus();


                    window.scrollTo({
                        top: target.offsetTop,
                        behavior: 'smooth'
                    });
                }
            }

            $events.delegate.on('click', btnSelector, this.handleClick)
        },
        onDestroy() {
            $events.delegate.off('click', btnSelector, this.handleClick)
        }
    })
}
